import { Employee } from '../types/interfaces';

export const UsersTemplate: Employee = {
  id: '',
  key: '',
  personnelNumber: '',
  label: '',
  fullName: '',
  surname: '',
  name: '',
  middleName: '',
  phone: '',
  email: '',
  productivity: '',
  isCustomProductivity: true,
  department: [],
  isUser: false,
  login: '',
  password: '',
  userRole: [],
  inheritedRoles: []
};
